import { Heading, Box, Button } from '@chakra-ui/react';
import { getTranslation } from '../utils/translations';
import { i18n } from '@shared';
import { useSurveyContext } from '../context/SurveyContext';
import { useTranslation } from 'react-i18next';
import { darkenHex, getReadableTextColor } from '../utils/colors';

export default function StartPage({ currentPage, setPage }: { currentPage: number; setPage: (value: number) => void }) {
	const { t } = useTranslation();
	const { survey } = useSurveyContext();
	const surveyHasBeforeParagraph = getTranslation(survey.translations, 'surveys.beforeParagraph', i18n.resolvedLanguage || 'fi', false) !== '';

	return (
		<>
			<Heading className="tav-survey-start-page-heading" color="black" textAlign={'center'}>
				{getTranslation(survey.translations, 'surveys.title', i18n.resolvedLanguage || 'fi')}
			</Heading>
			{surveyHasBeforeParagraph ? (
				<Box
					className="tav-survey-before-paragraph"
					marginTop={4}
					marginBottom={4}
					dangerouslySetInnerHTML={{ __html: getTranslation(survey.translations, 'surveys.beforeParagraph', i18n.resolvedLanguage || 'fi') }}
				/>
			) : null}
			<Button
				className="tav-survey-start-button"
				backgroundColor={survey.colorScheme}
				_hover={{
					backgroundColor: darkenHex(survey.colorScheme, 20),
				}}
				onClick={() => setPage(currentPage + 1)}
				marginLeft="auto"
				marginRight="auto"
				marginTop="auto"
				color={getReadableTextColor(survey.colorScheme)}
			>
				{t('general.start')}
			</Button>
		</>
	);
}
